import React from "react";
import SearchBox from "components/SearchBox";
import Box from "components/UI/Box";
import CollapsableRow from "components/CollapsableRow";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import SearchFilter from "../Modals/SearchFilter";
import FilterItem from "components/FilterItem";
import Pagination from "components/Pagination";
import { Link } from "react-router-dom";
import Button from "components/UI/Button";
import theme from "../../../../Theme/theme";
import ForceUpdateModal from "../Modals/ForceUpdateModal";
import { Constants } from "../../../../common/constants";
import { FilePicker } from "react-file-picker";

const access_level = localStorage.getItem("access_level");
const ONGOING_TEXT = "ONGOING"
const NO_SESSIONS_TEXT = "No Sessions"

const SECTION_IN_VPT = 1;
const SECTION_IN_GYM = 2;
const SECTION_OTHER = 3;

class Users extends React.Component {
  componentDidMount() {
    this.getUsers();
  }

  constructor(props) {
    super(props);
    let storedState = localStorage.getItem(Constants.STATE_USERS);
    if (storedState)
        storedState = JSON.parse(storedState);
    this.state = storedState ? storedState : {
      users: [],
      filteredUsers: [],
      showFilter: false,
      filters: {
        age: null,
        minutes: null,
        gender: null
      },
      currentPage: 0,
      rowCount: Constants.DEFAULT_PAGINATION_COUNT,
      editForceUpdate: false,
      forceUpdateData: {},
      searchQuery: null,
      totalPages: 0,
      selectedSection : SECTION_IN_VPT
    };
  }

  componentWillUnmount() {
    localStorage.setItem(Constants.STATE_USERS, JSON.stringify(this.state));
}

  searchHandler = e => {
    //Move the current page to 1, when start searching
    if(this.timeOut) clearTimeout(this.timeOut) // Hit api only if there is no event for 500 ms
    this.setState({
      ...this.state,
      currentPage: 0,
      searchQuery: e.target.value.toLowerCase()
    }, () => {
      this.timeOut = setTimeout(()=> {
        this.getUsers() // Hit api only if there is no event for 500 ms
        this.timeOut = null
      }, 500);
    });
  };

  isPromoCodeFlow =()=>{
    return this.props.location.state && this.props.location.state.promoId
  }

  getUsers() {
    if(this.state.currentPage < 0) return
    const toastId = toast("Fetching Users...");
    const access_token = localStorage.getItem("access_token");
    const promoUrl = this.isPromoCodeFlow()
    ? "admin/users?pagination=true&promo_id=" + this.props.location.state.promoId
    : "admin/users?pagination=true"
    let url = promoUrl + "&cpp=" + this.state.rowCount + "&index=" + this.state.currentPage
    url = url + "&gymMode=" + this.state.selectedSection;
    if (this.state.searchQuery) {
      url = url + "&search=" + encodeURIComponent(this.state.searchQuery)
    }
    axios.get(`${API_URL}/${url}`, {
      headers: {
        "x-access-token": access_token
      }
    })
    .then(res => {
      if (!res.error) {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          users: res.data.users,
          filteredUsers: res.data.users,
          totalPages: res.data.pagination ? res.data.pagination.total : 0
        });
      } else {
        if (res.error === 'Invalid Auth Token') {
          window.location.assign("/");
        }
      }
    })
    .catch(err => {
      ERROR_HANDLE(err);
    });
  }

  showFilterModal = () => {
    this.setState({
      showFilter: true
    });
  };
  closeFilter = () => {
    this.setState({
      showFilter: false
    });
  };

  selectFilter = filters => {
    this.setState({
      filters,
      showFilter: false
    });
  };

  editForceUpdate() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Fetching version details...");
    axios
      .get(`${API_URL}/version`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        try {
          let data = res.data;
          this.setState({
            forceUpdateData: data,
            editForceUpdate: true
          })
        } catch (e) {
          // Don't do any thing.
        }
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  exportUsers() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Users...");
    axios
      .get(`${API_URL}/report/users`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "users.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  exportWalletTransactions() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Wallet Transactions...");
    axios
      .get(`${API_URL}/admin/export/wallet_transactions`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "wallet_transactions_all.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  //This lets upload the csv contains add/remove promos to users
  uploadUsersPromos = (file) => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Processing...");
    const data = new FormData();
    data.append("csv", file);
    axios.post(`${API_URL}/promos/bulk_promos_csv`, data, {
      headers: {
        "x-access-token": access_token
      }
    }).then(res => {
      if (!res.error) {
        toast.dismiss(toastId);
        toast.success("Upload " + res.data.message, { autoClose: 1500 });
        this.getUsers();
      } else {
        if (res.error === 'Invalid Auth Token') {
          window.location.assign("/");
        } else toast.error(res.error, { autoClose: 1500 });
      }
    }).catch(error => {
      toast.dismiss(toastId);
      toast.error("Upload failed " + error.response.data.message);
    })
  }

  exportSessions() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Sessions...");
    axios
      .get(`${API_URL}/report/sessions`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "sessions.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  removeFilter = index => {
    switch (index) {
      case 0: {
        this.setState({
          filters: {
            age: null
          }
        });
        break;
      }
      case 1: {
        this.setState({
          filters: {
            minutes: null
          }
        });
        break;
      }
      case 2: {
        this.setState({
          filters: {
            gender: null
          }
        });
        break;
      }
      default:
        console.log("Filter Not Found");
    }
  };

  filter = () => {
    let { filters, filteredUsers } = this.state;
    if (filters.gender)
      filteredUsers = filteredUsers.filter(user => {
        let gender = user.gender
          ? user.gender.toLowerCase()[0] === "f"
            ? "Female"
            : "Male"
          : " ";

        return gender === filters.gender;
      });

    if (filters.age)
      filteredUsers = filteredUsers.filter(user => {
        const age = moment().diff(user.birthday, "years") || 0;
        return age > filters.age.min && age < filters.age.max;
      });

    if (filters.minutes)
      filteredUsers = filteredUsers.filter(user => {
        let { min, max } = filters.minutes;
        let minutes = parseInt(user.total_minutes, 10) / 60000;
        return minutes > min && minutes < max;
      });

    return filteredUsers;
  };

  userRows=users => {
    return users.map(currentItem => {
      const duration = moment.duration(currentItem.total_minutes);
      /* const hours = duration.hours();
      const mins = duration
        .minutes()
        .toString()
        .padStart(2, "0");
      const secs = duration
        .seconds()
        .toString()
        .padStart(2, "0"); */
      const style = {
        itemWrapper: {
          display: "flex",
          width: "100%",
          alignItems: "center",
          paddingLeft: "3px"
        },
        item: {
          flex: "1"
        },
        button: {
          width: "77px",
          height: "29px",
          fontSize: "16px",
          fontWeight: theme.fontWeight.regular,
          color: theme.color.thickGrey
        },
        collapsableWrapper: {
          backgroundColor: "#000",
          color: "#b5b5b6",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 30px"
        },
        collapseLabel: {
          fontSize: "10px"
        },
        collapseItem: {
          margin: "0px"
        },
        profileImageWrapper: {
          objectFit: "cover",
          borderRadius: "100%",
          flex: 0.5
        },
        longItem: {
          flex: "1.6"
        },
        profileImage: {
          borderRadius: "100%"
        }
      };
      const itemWrapper = currentItem.is_session_active ? { ...style.itemWrapper, ...{ background: theme.color.mediumPrimaryBlue, marginTop: -10, marginBottom: -10 } } : style.itemWrapper
      const itemStyle = currentItem.is_session_active ? { ...style.item, ...{ color: theme.color.white, fontWeight: theme.fontWeight.bold } } : style.item
      const buttonStyle = currentItem.is_session_active ? { ...style.button, ...{ background: theme.color.white, borderColor: theme.color.thickGrey, color: theme.color.thickGrey } } : style.button
      const persistent = (
        <div>
          <hr style={{ borderTop: "1px solid #b5b5b6", borderRadius: "0.5px" }} />
          <div style={itemWrapper}>
            <p style={itemStyle}>{currentItem.name}</p>
            <p style={itemStyle}>{currentItem.sessions_count}</p>
            <p style={itemStyle}>{currentItem.revenue.toFixed(2)}</p>
            <p style={itemStyle}>{currentItem.amount_paid.toFixed(2)}</p>
            <p style={itemStyle}>{currentItem.active_promocode ? currentItem.active_promocode : "-"}</p>
            <p style={itemStyle}>{currentItem.wallet_amount ? currentItem.wallet_amount : "-"}</p>
            <p style={itemStyle}>{currentItem.last_gym ? currentItem.last_gym : " "}</p>
            <p style={itemStyle}>{formatDurationInHours(duration)}</p>
            {
              currentItem.is_session_active ? <p style={itemStyle}>{ONGOING_TEXT}</p> :
                <p style={itemStyle}>{currentItem.last_session_date
                  ? moment(currentItem.last_session_date).format("MM/DD/YYYY")
                  : " "}</p>
            }
            < Link
              style={{ flex: 1 }}
              to={{
                pathname: this.isPromoCodeFlow() ?"/promocodes/users/user/" : "/users/user/",
                state: { gym_id: currentItem.user_id }
              }}
            >
              <Button
                type="holo"
                holo
                style={{ ...itemStyle, ...buttonStyle }}
                onClick={() => {
                  localStorage.setItem(
                    "flexitCurrentSingleUserID",
                    currentItem.user_id
                  );
                }}
              >
                View
              </Button>
            </Link>
          </div>
        </div >
      );
  
      const collapsable = (
        <div style={style.collapsableWrapper}>
          <div style={style.itemWrapper}>
            <div style={{ ...style.item, ...style.profileImageWrapper }}>
              <img
                style={style.profileImage}
                src={currentItem.profile_picture}
                alt="Profile"
                width="80px"
                height="80px"
              />
            </div>
            <p style={{ ...style.item, ...style.collapseItem }}>
              {currentItem.name}
            </p>
            <div style={{ ...style.item, ...style.collapseItem }}>
              <p>{"Phone: " + currentItem.phone}</p>
              <p>
                {"Age: " + moment().diff(currentItem.birthday, "years") || ""}
              </p>
              <p>
                {"Gender: " + (currentItem.gender
                  ? currentItem.gender.toLowerCase()[0] === "f"
                    ? " Female"
                    : " Male"
                  : " ")}
              </p>
            </div>
            <div style={{ ...style.item }}>
              <img src={require("assets/images/dob.png")} alt="Gym Hours" />
              <p style={{ ...style.item, ...style.collapseItem }}>{`DOB: ${moment(
                currentItem.birthday
              ).format("MM/DD/YYYY")}`}</p>
            </div>
            <div style={{ ...style.item }}>
              <img src={require("assets/images/email.png")} alt="Gym Hours" />
              <p style={{ ...style.item, ...style.collapseItem }}>
                {currentItem.email}
              </p>
            </div>
            {/* <p style={{ ...style.item, ...style.collapseItem }}>
              {currentItem.address}
            </p> */}
            <div style={{ ...style.item }}>
              <img src={require("assets/images/emergency.png")} alt="Gym Hours" />
              <p
                style={{
                  ...style.item,
                  ...style.collapseItem,
                  ...style.longItem
                }}
              >{`EMERGENCY CONTACT: ${currentItem.emergency_contact.phone}`}</p>
            </div>
          </div>
        </div>
      );
      return { persistent, collapsable };
    });
  };

  renderSection = (sectionID, title) => <div className={`unselectable section ${this.state.selectedSection == sectionID ? "section-active" : ""}`} onClick={() => {
    if (this.state.selectedSection != sectionID) {
      this.setState({
        selectedSection: sectionID
      }, () => {
        // Fetch user details for selected tab.
        this.getUsers();
      })
    }
  }}>
    <div className={`label ${this.state.selectedSection == sectionID ? "label-active" : ""}`}>{title.toUpperCase()}</div>
  </div>

  render() {
    const { filters, showFilter, editForceUpdate, totalPages } = this.state;
    const rowCount = parseInt(this.state.rowCount)
    return (
      <div style={style.wrapper}>
        <SearchBox onChange={this.searchHandler} value={this.state.searchQuery}>
          {/* <div style={style.filterIconWrapper} onClick={this.showFilterModal}>
            <img
              style={style.filterIcon}
              src={require("assets/images/filter-white-nobg.png")}
              alt="filter icon"
            />
          </div> */}
        </SearchBox>
        <div className="section-container" style={{ alignSelf: 'center' }}>
          {this.renderSection(SECTION_IN_VPT, "VPT")}
          {this.renderSection(SECTION_IN_GYM, "In Gym")}
          {this.renderSection(SECTION_OTHER, "Other")}
        </div>

        <div style={style.filtersWrapper}>
          {filters.age != null && (
            <FilterItem
              name={`Age ${filters.age.min} - ${filters.age.max}`}
              crossAction={() => {
                this.removeFilter(0);
              }}
            />
          )}
          {filters.minutes != null && (
            <FilterItem
              name={`Minutes ${filters.minutes.min} - ${filters.minutes.max}`}
              crossAction={() => {
                this.removeFilter(1);
              }}
            />
          )}
          {filters.gender != null && (
            <FilterItem
              name={`${filters.gender}`}
              crossAction={() => {
                this.removeFilter(2);
              }}
            />
          )}
        </div>

        <Box style={style.box} outline>
          {!this.isPromoCodeFlow() && <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
              style={{
                ...style.exportButton,
                borderRadius: "5px",
                margin: "8px"
              }}
              type="primary"
              onClick={() => this.editForceUpdate()}
            >
              Force Update
            </Button>
            {
              access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_2 || access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_3
              ? null
                : <div style={style.buttonsContainer}>
              <Button
            style={{
              ...style.exportButton,
              borderRadius: "5px",
              margin: "8px"
            }}
            type="primary"
            onClick={() => this.exportUsers()}
          >
            Export Users
            
          </Button>
          <Button
            style={{
              ...style.exportButton,
              borderRadius: "5px",
              margin: "8px"
            }}
            type="primary"
            onClick={() => this.exportSessions()}
          >
            Export Sessions
          </Button>
          <Button
            style={{
              ...style.exportButton,
              width: 220,
              borderRadius: "5px",
              margin: "8px"
            }}
            type="primary"
            onClick={() => this.exportWalletTransactions()}
          >
            Export Wallet Transactions
          </Button>
            <FilePicker onChange={this.uploadUsersPromos}>
              <Button
                style={{
                  ...style.exportButton,
                  borderRadius: "5px",
                  margin: "8px",
                  width: "220px"
                }}
                type="primary"
                onClick={(e) => {
                  e.stopPropagation()
                }}>
                Upload Add/Remove Promos
              </Button>
            </FilePicker>
              </div>
            }
          </div>}
          {header()}
          {this.userRows(this.filter()).map((currentItem, i) =>
            <CollapsableRow data={currentItem} key={i} />
          )}
        </Box>
        <Pagination
          currentPage={this.state.currentPage}
          pageCount={totalPages}
          rowCount={rowCount}
          pageAction={pageNumber => {
            this.setState({ ...this.state, currentPage: pageNumber }, ()=>{
              this.getUsers()
            });
          }}
          updateRowCount={(rowCount) => {
            this.setState({ rowCount, currentPage: 0 }, ()=>{
              this.getUsers()
            });
          }}
        />
        {showFilter && (
          <SearchFilter
            close={this.closeFilter}
            setFilter={this.selectFilter}
          />
        )}
        {editForceUpdate && <ForceUpdateModal
          data={this.state.forceUpdateData}
          close={() => {
            this.setState({
              editForceUpdate: false
            })
          }} />}
      </div>
    );
  }
}
export default Users;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center"
  },
  filterIconWrapper: {
    margin: "0px 20px",
    backgroundColor: "#00b4d2",
    borderRadius: "100%",
    padding: "15px",
    cursor: "pointer"
  },
  filterIcon: {
    width: "30px",
    height: "30px"
  },
  box: {
    width: "1200px"
  },
  titleWrapper: {
    display: "flex",
    paddingLeft: "3px"
  },
  titleItem: {
    flex: "1",
    fontSize: "20px",
    color: "#00b4d2"
  },
  filtersWrapper: {
    display: "flex",
    justifyContent: "center"
  },
  exportButton: {
    width: "150px",    
    height: "40px",
    fontSize: "15px"
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '40px'
  },
};

const headerlabels = [
  "Name",
  "Sessions",
  "Revenue",
  "Amount Paid",
  "Promocode",
  "Wallet Amount",
  "Last Gym",
  "Overall Minutes",
  "Last Session Date",
  "Profile"
];
const headerItems = headerlabels.map((label, i) => (
  <p style={style.titleItem} key={i}>
    {label}
  </p>
));

const header = () => <div style={style.titleWrapper}>{headerItems}</div>;

const formatInTwoDigit = (value) => {
  return value > 9 ? value : "0" + value
}

const formatDurationInHours = duration => {
  if (duration > 0) {
    var milliSeconds = Math.floor((duration / 1000) / 60 * 60);
    var hours = Math.floor(milliSeconds / 3600);
    var minutes = Math.floor(milliSeconds % 3600 / 60);
    var seconds = Math.floor(milliSeconds % 3600 % 60);
    return formatInTwoDigit(hours) + ":" + formatInTwoDigit(minutes) + ":" + formatInTwoDigit(seconds);
  } else {
    return NO_SESSIONS_TEXT
  }
}
